import { z } from 'zod'
import { Identity } from '~library/enums'

/** 企業會員綁定 Response Schema */
export const companyEmployeeBindingResponseSchema = z.object({
  /** 企業代碼 */
  bizId: z.string(),
  /** 身份 */
  identity: z.nativeEnum(Identity)
})

/** 企業會員綁定 Response */
export interface CompanyEmployeeBindingResponse
  extends z.infer<typeof companyEmployeeBindingResponseSchema> {}
